/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Feature } from 'src/luis/modules/features/types/Feature';
import { Intent } from 'src/luis/modules/intents/Intent';
import { ModelType } from 'src/luis/types/ModelType';
import { EntityStore } from 'src/luis/types/stores/entities/EntityStore';
import { PhraseListStore } from 'src/luis/types/stores/features/PhraseListStore';
import { IntentStore } from 'src/luis/types/stores/intents/IntentStore';

/**
 * Denormalizes intents using entity and phrase list stores.
 */
export const intentsDenormalizer = (
    intentStores: IntentStore[],
    entityStores: EntityStore[],
    phraseListStores: PhraseListStore[]
): Intent[] =>
    intentStores.map<Intent>(intent => ({
        ...intent,
        labelsCount: intent.labelsCount,
        features: intent.featureStoreHouse.items
            .map(d => {
                const model =
                    d.typeId === 'feature'
                        ? phraseListStores.find(p => p.id === d.id)
                        : intentStores.find(i => i.id === d.id) || entityStores.find(e => e.id === d.id);
                if (!model) {
                    return;
                }

                return <Feature>{
                    id: d.id,
                    name: model.name,
                    typeId: d.typeId === 'feature' ? 'feature' : (<IntentStore>model).typeId === ModelType.Intent ? 'intent' : 'entity'
                };
            })
            .filter(Boolean)
    }));
